










































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';

import Widget from '@/components/Utils/Widget.vue';
import {Inject} from 'inversify-props';
import {getModule} from 'vuex-module-decorators';
import LoraHardwareStore from '@/store/lora/LoraHardware.store';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {Widget},
})
export default class LoraHardwareWidget extends Mixins<BaseComponent>(BaseComponent) {
  private loraHardwareStore: LoraHardwareStore = getModule(LoraHardwareStore, this.$store);

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.setLoading();
    try {
      await this.loraHardwareStore.fetchRegion();
      await this.loraHardwareStore.fetchAntenna();
    } catch (error) {
      Notify.Error(this.logger, `Could not get lora hardware information`, error);
    } finally {
      this.setLoaded();
    }
  }
}
